import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconCardLayout } from 'view/layout/icon-card-layout';
import type { RequestTypeSuggestion } from 'state/persisted/request-type-suggestion';
import { AutoScaledImage } from 'view/common/auto-scaled-image';
import messages from './messages';
import { RecentFormsListItem } from './recent-forms-list-item';
import { RecentFormsContainer, RecentFormItem, RecentFormsHeader } from './styled';

interface RecentFormsProps {
    isUserLoggedIn: boolean;
    suggestedRequestTypes: RequestTypeSuggestion[];
    onClick?: (index: number) => void;
    isEmbeddedRoute?: boolean;
}

export default class RecentForms extends React.Component<RecentFormsProps> {
    onClick = (index: number) => () => {
        const { onClick } = this.props;
        onClick && onClick(index);
    };

    render() {
        const { suggestedRequestTypes, isUserLoggedIn, isEmbeddedRoute } = this.props;
        const headerTitle = isUserLoggedIn ? messages.headerTitle : messages.headerTitleAnon;
        return (
            <div>
                <RecentFormsHeader>
                    <FormattedMessage {...headerTitle} />
                </RecentFormsHeader>

                <RecentFormsContainer>
                    {suggestedRequestTypes.map((recentRequestSuggestion: RequestTypeSuggestion, recentFormIndex) => {
                        const Icon = <AutoScaledImage src={recentRequestSuggestion.iconUrl} alt="" />;

                        const LinkAndDescription = (
                            <RecentFormsListItem
                                {...recentRequestSuggestion}
                                onClick={this.onClick(recentFormIndex)}
                                isEmbeddedRoute={isEmbeddedRoute}
                            />
                        );

                        return (
                            <RecentFormItem key={`recentRequestSuggestion_${recentRequestSuggestion.id}`}>
                                <IconCardLayout padding={0} leftIcon={Icon} content={LinkAndDescription} />
                            </RecentFormItem>
                        );
                    })}
                </RecentFormsContainer>
            </div>
        );
    }
}
